import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[specCollectionHost]'
})
export class SpecCollectionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}